const smsapi = "https://smsapi.huestimates.net/SendSms";

const login = "https://login-ui.progress-ims.com/signIn";

const fileurl = process.env.NODE_ENV === "production"
  ? "https://subro-files.progress-ims.com/Files/"
  : "http://localhost:5004/";

const api = process.env.NODE_ENV === "production"
  ? "https://subro-api.progress-ims.com/api"
  : "https://localhost:44332/api";

let baseURL = window.location.origin;

const weblink = process.env.NODE_ENV === "production"
  ? baseURL + "/"
  : "http://localhost:8080/";

let subrogationData = [
  {
    id: "39",
    accidentId: "2",
    claimId: "111",
    insuranceContract: "ABC Sığorta",
    policyNumber: "SIM487628",
    dispClaimNumber: "00729/01",
    insuranceTypeName: "İcbari",
    policyType: 1,
    branchName: "Yasamal filialı",
    insuredName: "Sabir Mehdiyev",
    insuredItemModel: "Mercedes-Benz C-250",
    insuredItemRegNum: "00BB100",
    insuredItemYear: 2023,
    numberOfSeats: 4,
    startDateStr: "01.03.2024 14:38:08",
    endDateStr: "01.03.2025 14:38:08",
    insuranceSum: "5500.00",
    accidentDateStr: "30.06.2025 11:51:54",
    claimStatus: "Yeni iş",
    callDateStr: "01.03.2025 14:38:08",
    place: "Yasamal parkı yaxınlığı",
    injuredName: "Əli Muradov",
    vehicleCount: 1,
    victimName: "Ələkbər Əfəndiyev",
    victimPhone: "+994556667788",
    damagedInsItemModel: "Mercedes-Benz C-250",
    damagedInsItemRegNum: "10BB100",
    damagedInsItemYear: "2022",
    damageCategoryName: "Yol nəqliyyat hadisəsi",
    medDamageTypeName: "Ölüm",
    basisPrice: "ABC Sığorta",
    damageDateStr: "01.03.2025 14:38:08",
    damageSumLetter: 150.00,
    damagePercentage: 100,
    paymentSumLetter: 150.00,
    paymentReceivedPerson: "MEHDİYEV SABİR",
    paymentReceivedPersonPhone: "0501234567",
    subrogationAmount: 250.00,
    insCompanyPlace: "Bakı, Nizami 15",
    insCompanyContact: "0121234567",
    insCompanyEmail: "info@sigorta.az",
    tortfeasorPlace: "Yasamal parkı yaxınlığı",
    paidAmount: 250.00,
    policyDate: "04.05.2024 15:38:08",
    companyPaymentDate: "01.03.2025 14:38:08",
    signatoryName: "Vəliyeva Günay T.",
    signatoryPosition: "Hüquqşünas",
    signerCompanyName: "ABC Sığorta"
  },
  {
    id: "48",
    accidentId: "2",
    claimId: "222",
    insuranceContract: "AAA Sığorta",
    policyNumber: "SIM445587",
    dispClaimNumber: "00730/01",
    insuranceTypeName: "İcbari",
    policyType: 2,
    branchName: "Yasamal filialı",
    insuredName: "Aqil Hüseynov",
    insuredItemModel: "BMW M5",
    insuredItemRegNum: "00SS500",
    insuredItemYear: 2023,
    numberOfSeats: 4,
    startDateStr: "12.06.2025 14:38:08",
    endDateStr: "01.03.2025 14:38:08",
    insuranceSum: "2330.00",
    accidentDateStr: "05.07.2025 16:07:51",
    claimStatus: "Yeni iş",
    callDateStr: "01.03.2025 14:38:08",
    place: "X petrol qarşısı",
    injuredName: "Kamil Allahverdiyev",
    vehicleCount: 1,
    victimName: "Aslan Məmmədzadə",
    victimPhone: "+994551234567",
    damagedInsItemModel: "BMW M5",
    damagedInsItemRegNum: "10BB100",
    damagedInsItemYear: "2022",
    damageCategoryName: "Yol nəqliyyat hadisəsi",
    medDamageTypeName: "Ölüm",
    basisPrice: "AAA Sığorta",
    damageDateStr: "01.03.2025 14:38:08",
    damageSumLetter: 150.00,
    damagePercentage: 100,
    paymentSumLetter: 150.00,
    paymentReceivedPerson: "Fərhad Hüseynov",
    paymentReceivedPersonPhone: "0501234567",
    subrogationAmount: 420.00,
    incidentCauseReason: "Səbəb1",
    insCompanyPlace: "Bakı, Nizami 15",
    insCompanyContact: "0121234567",
    insCompanyEmail: "info@azersigorta.az",
    tortfeasorPlace: "X petrol qarşısı",
    paidAmount: 420.00,
    policyDate: "01.03.2025 14:38:08",
    companyPaymentDate: "01.03.2025 14:38:08",
    signatoryName: "Məmmədova Günay T.",
    signatoryPosition: "Hüquqşünas",
    signerCompanyName: "AAA Sığorta"
  }
];

const respUsers = [
  { id: 1, name: "Kamran Qurbanov", phone: "+994501234567" },
  { id: 2, name: "Rufiz Hüseynzadə", phone: "+994502223344" },
  { id: 3, name: "Orxan Məmmədəliyev", phone: "+994505556677" },
  { id: 4, name: "Sabir Mehdiyev", phone: "+994507778899" },
  { id: 5, name: "Leyla Rzayeva", phone: "+994509998877" },
  { id: 6, name: "Ramin Abbasov", phone: "+994551234567" },
  { id: 7, name: "Kamilə Əhmədova", phone: "+994552223344" },
  { id: 8, name: "Orxan Vəliyev", phone: "+994553334455" },
  { id: 9, name: "Günay Cəfərova", phone: "+994554445566" },
  { id: 10, name: "Tural Nəsibov", phone: "+994555556677" }
];


const respPersonData =
  [
    {
      pin: "ABC1234",
      tin: "123",
      name: "Elvin",
      surname: "Əliyev",
      fatherName: "Rəşid",
      mobilePhone: "0501234567",
      additionalMobilePhone: "0517654321",
      gender: 1,
      dateOfBirth: "1990-05-10",
      regAddress: "Bakı, Yasamal",
      workplace: "ABC LLC",
      representative: "Test"
    },
    {
      pin: "XYZ5678",
      tin: "234",
      name: "Aynur",
      surname: "Mammadova",
      fatherName: "Ilham",
      mobilePhone: "0559876543",
      additionalMobilePhone: "0701234567",
      gender: 2,
      dateOfBirth: "1988-08-15",
      regAddress: "Gəncə, Kəpəz",
      workplace: "LMN LLC",
      representative: "Test2"
    }
  ];


const standalone = true;

function ShowLink(value) {
  var text = value;
  var exp = /\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}


function HtmlNewLine(value) {
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function Round2(num) {
  return Math.round(num * 100) / 100;
}

function DaysBetween(dt1, dt2) {
  var oneday = 1000 * 60 * 60 * 24;
  dt1 = new Date(dt1);
  dt2 = new Date(dt2);
  var diff = Math.round(dt2.getTime() - dt1.getTime()) / oneday;

  var res = diff.toFixed(0);
  return res;
}

function DateToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  return date + "." + month + "." + year;
}

function DateTimeToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  return (
    date + "." + month + "." + year + " " + hour + ":" + minutes
  );
}

function DateTimeReverseToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  return (
    date + "." + month + "." + year + " " + hour + ":" + minutes
  );
}


function DateTimeReverseToString1(dt) {

  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    month + "-" + date + "-" + year + " " + hour + ":" + minutes + ":" + seconds
  );
}

function DateTimeToJson(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    year + "-" + month + "-" + date + "T" + hour + ":" + minutes + ":" + seconds
  );
}

function AddMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

function AddDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
function MonthName(month) {
  const monthNames = [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "İyun",
    "İyul",
    "Avqust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr"
  ];
  return monthNames[month];
}

function NumberFormat(val, digits) {
  return val.toLocaleString(
    "ru-RU", // leave undefined to use the visitor's browser
    // locale or a string like 'en-US' to override it.
    { minimumFractionDigits: digits }
  );
}

export {
  ShowLink,
  HtmlNewLine,
  smsapi,
  fileurl,
  standalone,
  Round2,
  DaysBetween,
  DateToString,
  DateTimeToString,
  AddMonths,
  AddDays,
  MonthName,
  NumberFormat,
  DateTimeToJson,
  DateTimeReverseToString,
  DateTimeReverseToString1,
  login,
  api,
  weblink,
  subrogationData,
  respUsers,
  respPersonData
};
